// React
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Locales
import translate from 'locales/i18n';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloneIcon from '@mui/icons-material/FileCopy';
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
// Action
import AccountAction from 'actions/AccountAction';

class DialogDuplicateAccount extends React.PureComponent {

    state = {
        name: ''
    };

    static propTypes = {
        classes: PropTypes.object.isRequired,
        open: PropTypes.bool,
        account: PropTypes.object,
        close: PropTypes.func,
        fullScreen: PropTypes.bool,
    };

    static defaultProps = {
        account: {}
    };

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    duplicateAccount = () => {
        const newAccount = Object.assign({}, this.props.account);
        newAccount.name = this.state.name;

        AccountAction.duplicateAccount(newAccount);

        this.props.close();
    };

    render() {
        const { fullScreen, classes } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.props.close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
            >
                <IconButton color='secondary' onClick={this.props.close} className={classes.closeButton}>
                    <ClearIcon />
                </IconButton>
                <DialogTitle id='responsive-dialog-title'>{translate.i18n('DUPLICATE_ACCOUNT', { name: this.props.account.name })}</DialogTitle>

                <DialogContent className={classNames(!fullScreen && classes.dialogContentNotFullScreen, classes.dialogContent)}>
                    <TextField
                        id='account-name'
                        className={classNames(classes.textField)}
                        variant='outlined'
                        type='text'
                        label={translate.i18n('NEW_ACCOUNT_NAME')}
                        value={this.state.name}
                        onChange={this.handleChange('name')}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color='primary' size='small'
                        onClick={this.duplicateAccount}>
                        <CloneIcon className={classes.leftIcon} />
                        {translate.i18n('DUPLICATE')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    dialogContentNotFullScreen: {
        minWidth: '350px',
        display: 'flex',
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textField: {
        margin: theme.spacing(1),
        width: '80%'
    },
    closeButton: {
        position: 'absolute',
        right: '2px',
        top: '2px'
    },
    leftIcon: {
        marginRight: theme.spacing(1),
        fontSize: 20
    },
});

export default withStyles(styles)(DialogDuplicateAccount);
